import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.444 1H6.556c-.413 0-.809.166-1.1.46A1.58 1.58 0 0 0 5 2.571v4.452c0 .34.11.67.311.943l2.022 2.725v10.738c0 .416.164.816.456 1.11s.687.461 1.1.461h6.222c.413 0 .808-.166 1.1-.46a1.58 1.58 0 0 0 .456-1.111V10.69l2.022-2.725c.201-.272.31-.603.311-.943V2.571a1.58 1.58 0 0 0-.456-1.11 1.55 1.55 0 0 0-1.1-.461M6.556 2.571h10.888V4.93H6.556zm8.866 7.177c-.201.272-.31.603-.31.943v10.738H8.888V10.69c0-.34-.11-.67-.311-.943L6.556 7.023V6.5h10.888v.523zm-2.644 1.466v3.143a.8.8 0 0 1-.228.556.774.774 0 0 1-1.1 0 .8.8 0 0 1-.228-.556v-3.143a.8.8 0 0 1 .228-.555.774.774 0 0 1 1.1 0 .8.8 0 0 1 .228.555"
    }, null, -1)
  ]))]))
}
export default { render: render }